import axios from "axios"
import Swal from "sweetalert2"
import _Util from '../helper/_Util'
import { message } from 'antd';

const URI_API = process.env.REACT_APP_URL_API

const session = async () =>{
  try {
      let result = await axios.get(`${URI_API}/session`,{withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        return false
      }
    }catch(err){
      
      _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const permission = async (module) =>{
  try {
      let result = await axios.get(`${URI_API}/permission/${module}`,{withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        return false
      }
    }catch(err){
      
      _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const login = async (email, password) =>{
    try {
        let result = await axios.post(`${URI_API}/login`, {email, password},{withCredentials: true})
        if(result.data.status){
          return result.data.data
        }else{
          Swal.fire({
            icon: 'error',
            title: result.data.msg,
            confirmButtonText: "ปิด",
            timer: 3000
          })
          return false
        }
      }catch(err){
       
       _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
        return false
      }
}

const logout = async () =>{
  try {
      let result = await axios.get(`${URI_API}/logout`, {withCredentials: true})
      if(result.data.status){
        return result.data.data
      }else{
        message.error(result.data.msg)
        return false
      }
    }catch(err){
     
     _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const register = async (data) =>{
  try {
      let result = await axios.post(`${URI_API}/register`, data,{withCredentials: true})
      if(result.data.status){
        Swal.fire({
          title: "ลงทะเบียนผู้ใช้งานสำเร็จ",
          icon: "success",
          timer: 3000
        })
        return result.data.data
      }else{
        Swal.fire({
          icon: 'error',
          title: result.data.msg,
          confirmButtonText: "ปิด",
          timer: 3000
        })
        return false
      }
    }catch(err){
      
      _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
      return false
    }
}

const forgetPwdSendEmail = async (data) =>{
  try {
    let result = await axios.post(`${URI_API}/forget-pwd/send`, data, {withCredentials: true})
    if(result.data.status){
      Swal.fire({
        title: "กรุณาตรวจสอบกล่องข้อความในอีเมลของคุณ",
        icon: "success",
        timer: 3000
      })
      return result.data.data
    }else{
      Swal.fire({
        icon: 'error',
        title: result.data.msg,
        confirmButtonText: "ปิด",
        timer: 3000
      })
      return false
    }
  }catch(err){
    
    _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
    return false
  }
}

const forgetPwdResetPassword = async (data) =>{
  try {
    let result = await axios.post(`${URI_API}/forget-pwd/reset-password`, data, {withCredentials: true})
    if(result.data.status){
      return true
    }else{
      Swal.fire({
        icon: 'error',
        title: result.data.msg,
        confirmButtonText: "ปิด",
        timer: 3000
      })
      return false
    }
  }catch(err){
    
    _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
    return false
  }
}

const forgetPwdVerifyToken = async (token) =>{
  try {
    let result = await axios.post(`${URI_API}/forget-pwd/verify`, {token: token}, {withCredentials: true})
    if(result.data.status){
      return result.data.data
    }else{
      Swal.fire({
        icon: 'error',
        title: result.data.msg,
        confirmButtonText: "ปิด",
        timer: 3000
      }).then((resp, err)=>{
        // window.location.href = "/"
      })
      return false
    }
  }catch(err){
    
    _Util.handleAxiosStatus(err.response.status, err.response.data.msg)
    return false
  }
}

const exports = {
  session,
  permission,
  register,
  login,
  logout,
  forgetPwdSendEmail,
  forgetPwdVerifyToken,
  forgetPwdResetPassword
}

export default exports 